import { compose, toPairs, map, find, prop } from 'ramda';
import Legislation from './pages/Legislation/Loadable';
import Workflow from './fsm/Workflow/workflow';

const routes = {
  LEGISLATION: {
    path: '/legislation',
    exact: false,
    component: Legislation,
  },
  WORKFLOW: {
    path: '/',
    exact: true,
    default: true,
    component: Workflow,
  },
};

export const allRoutes = compose(
  map(([name, r]) => ({ ...r, name })),
  toPairs
)(routes);
export const defaultRoute = find(r => r.default)(allRoutes);
export default routes;
export const getPath = prop('path');
